import axios, { AxiosError } from 'axios';
import { message } from 'antd';
import { useAuthStore } from '../store/auth';

const attachAuth = (config: any) => {
  const token = useAuthStore.getState().token;
  if (token) {
    config.headers.set('Authorization', `Bearer ${token}`);
  }
  return config;
};

const handleAuthError = (err: AxiosError<any>) => {
  if (err.response?.status === 401) {
    const url = err.config?.url ?? '';
    if (!url.includes('/platform/auth/login')) {
      useAuthStore.getState().clear();
      // 部署在 /admin/ 子路径下，登录跳转需带前缀（与 vite base / Router basename 一致）
      window.location.href = '/admin/login';
      return Promise.reject(err);
    }
  }
  const msg = err.response?.data?.message || err.message;
  message.error(typeof msg === 'string' ? msg : JSON.stringify(msg));
  return Promise.reject(err);
};

export const api = axios.create({
  baseURL: '/api',
  timeout: 15_000,
});
api.interceptors.request.use(attachAuth);
api.interceptors.response.use(
  (resp) => {
    if (resp.data && typeof resp.data === 'object' && 'ok' in resp.data) {
      if (resp.data.ok) return resp.data.data ?? null;
      throw new Error((resp.data as any).message || '请求失败');
    }
    return resp.data;
  },
  handleAuthError,
);
